module.exports = __webpack_public_path__ + "static/media/lexikon_avacon.b332be05.svg";